<template>
    <section
        :id
        class="border-ds-primary-200 py-6 text-content-primary [&:not(:first-of-type)]:border-t"
    >
        <AddFileSectionHeader
            v-if="sectionHeading"
            :heading="sectionHeading"
        >
            <slot name="trailing" />
        </AddFileSectionHeader>
        <p
            v-if="sectionDescription"
            class="mt-1 text-content-md"
        >
            {{ sectionDescription }}
        </p>
        <slot />
    </section>
</template>

<script setup lang="ts">
import type { AddFileFormSectionIds } from '@/company-portal/add-file/add-file.types';
import AddFileSectionHeader from '@/components/Views/Company/AddFile/AddFileSectionHeader.vue';

withDefaults(
    defineProps<{
        sectionHeading?: string;
        sectionDescription?: string;
        id: AddFileFormSectionIds;
    }>(),
    {
        sectionHeading: '',
        sectionDescription: '',
    },
);
</script>
